import { useBucket } from '@mc/experiments-react'
import { useUserInfo } from '@mc/user-info'
import { BOGO_OFFER_FLAG_NAME } from '../constants'

export const useBogo = ({ isGift = false }: { isGift?: boolean } = {}) => {
  const { user } = useUserInfo()
  const bucket = useBucket(BOGO_OFFER_FLAG_NAME)

  if (isGift) {
    return {
      isBogoOfferEligible: false,
    }
  }

  let isUserEligible = bucket === 'variant_1'

  if (isUserEligible && user) {
    isUserEligible = user.bogoEligible
  }

  return {
    isBogoOfferEligible: isUserEligible,
  }
}
